/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.tool.access.rpc.ToolAccessService
 */
import * as References from './ToolAccessService';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
export const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.tool.access.rpc.ToolAccessService#requestToolAccess
 */
export const REQUEST_TOOL_ACCESS_MUTATION_FIELD_NAME = 'com_hubspot_tool_access_rpc_ToolAccessService_requestToolAccess';
export const REQUEST_TOOL_ACCESS_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: REQUEST_TOOL_ACCESS_MUTATION_FIELD_NAME,
  args: ['scope', 'approverUserId', 'message'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.requestToolAccessRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.tool.access.rpc.ToolAccessService#getActiveToolAccessRequestForScope
 */
export const GET_ACTIVE_TOOL_ACCESS_REQUEST_FOR_SCOPE_QUERY_FIELD_NAME = 'com_hubspot_tool_access_rpc_ToolAccessService_getActiveToolAccessRequestForScope';
export const GET_ACTIVE_TOOL_ACCESS_REQUEST_FOR_SCOPE_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_ACTIVE_TOOL_ACCESS_REQUEST_FOR_SCOPE_QUERY_FIELD_NAME,
  args: ['scopeName', 'locale'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getActiveToolAccessRequestForScopeRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});